<template>
  <div class="wrapper" :style="wrapperStyle">
    <login-area v-if="showView==='login'" :propsList="propsList" v-on:loginSuccess="loginSuccess" v-on:loginFailed="loginFailed" @registerTextClick="registerTextClick" @forgetTextClick="forgetTextClick"></login-area>
    <register-area v-if="showView==='register'" @loginTextClick="loginTextClick"></register-area>
    <forget-password-area v-if="showView==='forgetpassword'" @returnToLogin="returnToLogin"  v-on:resetPasswordSuccess="resetPasswordSuccess"  v-on:resetPasswordFailed="resetPasswordFailed"></forget-password-area>
  </div>
</template>
<script>
import LoginArea from '../Area/LoginArea.vue'
import RegisterArea from '../Area/RegisterArea.vue'
import ForgetPasswordArea from '../Area/ForgetPasswordArea.vue'
export default {
  components: { LoginArea, RegisterArea, ForgetPasswordArea },
  props: {
    propsList: {
      type: Object
    }
  },
  data () {
    return {
      showView: 'login'
    }
  },
  computed: {
    wrapperStyle () {
      return {
        backgroundColor: this.propsList.backgroundColor
          ? this.propsList.backgroundColor
          : '#137d90',
        backgroundImage: 'url(' + this.propsList.backgroundImage + ')'
      }
    }
  },
  methods: {
    loginSuccess (value) {
      this.$emit('loginSuccess', value)
    },
    loginFailed (value) {
      this.$emit('loginFailed', value)
    },
    resetPasswordSuccess (value) {
      this.showView = 'login'
      this.$message.success('重置密码成功')
      this.$emit('resetPasswordSuccess', value)
    },
    resetPasswordFailed (value) {
      this.$message.success('重置密码失败')
      this.$emit('resetPasswordFailed', value)
    },
    registerTextClick () {
      this.showView = 'register'
    },
    loginTextClick () {
      this.showView = 'login'
    },
    forgetTextClick () {
      this.showView = 'forgetpassword'
    },
    returnToLogin () {
      this.showView = 'login'
    }
  }
}
</script>
<style lang="less" scoped>
.wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
}
</style>



// WEBPACK FOOTER //
// third_party/common_app/LoginModule/View/Page/LoginPage.vue